import { render } from "./OrganizationRegister.vue?vue&type=template&id=4902549c"
import script from "./OrganizationRegister.vue?vue&type=script&lang=js"
export * from "./OrganizationRegister.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__